// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Corrective Actions Panel Styles */

.corrective-actions-panel {
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.ca-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.ca-header h5 {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

.ca-header .btn {
  font-weight: 500;
  font-size: 0.9rem;
  padding: 6px 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* CA Form */
.ca-form {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
}

.ca-form .form-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 6px;
  font-size: 0.9rem;
}

.ca-form .form-control,
.ca-form .form-select,
.ca-form input,
.ca-form textarea {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 0.9rem;
}

.ca-form .form-control:focus,
.ca-form .form-select:focus,
.ca-form input:focus,
.ca-form textarea:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

.ca-form .is-invalid {
  border-color: #dc3545;
}

.ca-form .invalid-feedback {
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 4px;
  display: block;
}

.ca-form .btn {
  font-size: 0.9rem;
  padding: 6px 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

/* CA Table */
.corrective-actions-panel .table {
  margin-bottom: 0;
  font-size: 0.9rem;
}

.corrective-actions-panel .table-responsive {
  border-radius: 4px;
  overflow: hidden;
}

.corrective-actions-panel .table th {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
  font-size: 0.85rem;
  padding: 10px 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.corrective-actions-panel .table td {
  vertical-align: middle;
  padding: 10px 12px;
  color: #495057;
}

.corrective-actions-panel .table tbody tr {
  border-bottom: 1px solid #e9ecef;
}

.corrective-actions-panel .table tbody tr:hover {
  background-color: #f8f9fa;
}

.corrective-actions-panel .table-danger td {
  background-color: #f8d7da !important;
  font-weight: 500;
}

.corrective-actions-panel .table small {
  color: #6c757d;
}

.corrective-actions-panel .table .text-danger {
  color: #dc3545 !important;
}

/* Status Badges */
.corrective-actions-panel .badge {
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Action Buttons */
.corrective-actions-panel .btn-group {
  display: flex;
  gap: 4px;
}

.corrective-actions-panel .btn-group-sm .btn {
  padding: 4px 6px;
  font-size: 0.8rem;
  border-radius: 3px;
}

.corrective-actions-panel .btn-outline-secondary:hover {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

.corrective-actions-panel .btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}

/* Delete Confirmation Alert */
.corrective-actions-panel .alert-danger {
  border-left: 4px solid #dc3545;
  padding: 15px;
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.corrective-actions-panel .alert-danger .d-flex {
  gap: 10px;
}

.corrective-actions-panel .alert-danger svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.corrective-actions-panel .alert-danger p {
  margin: 0;
}

/* Empty State */
.corrective-actions-panel .alert-info {
  border-left: 4px solid #0d6efd;
  padding: 15px;
}

.corrective-actions-panel .alert-info p {
  margin: 0;
}

@media (max-width: 768px) {
  .corrective-actions-panel {
    padding: 15px;
  }

  .ca-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .ca-header .btn {
    width: 100%;
    justify-content: center;
  }

  .corrective-actions-panel .table {
    font-size: 0.8rem;
  }

  .corrective-actions-panel .table th,
  .corrective-actions-panel .table td {
    padding: 8px 6px;
  }

  .ca-form .row {
    gap: 0;
  }

  .ca-form .col-md-6 {
    margin-bottom: 10px;
  }

  .corrective-actions-panel .btn-group {
    width: 100%;
    flex-direction: column;
  }

  .corrective-actions-panel .btn-group .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditFindings/CorrectiveActionsPanel.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;EAIE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Corrective Actions Panel Styles */\n\n.corrective-actions-panel {\n  background-color: white;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 20px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.ca-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.ca-header h5 {\n  margin: 0;\n  color: #2c3e50;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.ca-header .btn {\n  font-weight: 500;\n  font-size: 0.9rem;\n  padding: 6px 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* CA Form */\n.ca-form {\n  background-color: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  padding: 15px;\n  margin-bottom: 20px;\n}\n\n.ca-form .form-label {\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 6px;\n  font-size: 0.9rem;\n}\n\n.ca-form .form-control,\n.ca-form .form-select,\n.ca-form input,\n.ca-form textarea {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 8px 10px;\n  font-size: 0.9rem;\n}\n\n.ca-form .form-control:focus,\n.ca-form .form-select:focus,\n.ca-form input:focus,\n.ca-form textarea:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);\n}\n\n.ca-form .is-invalid {\n  border-color: #dc3545;\n}\n\n.ca-form .invalid-feedback {\n  color: #dc3545;\n  font-size: 0.85rem;\n  margin-top: 4px;\n  display: block;\n}\n\n.ca-form .btn {\n  font-size: 0.9rem;\n  padding: 6px 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n/* CA Table */\n.corrective-actions-panel .table {\n  margin-bottom: 0;\n  font-size: 0.9rem;\n}\n\n.corrective-actions-panel .table-responsive {\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.corrective-actions-panel .table th {\n  background-color: #f8f9fa;\n  border-top: 1px solid #dee2e6;\n  border-bottom: 2px solid #dee2e6;\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.85rem;\n  padding: 10px 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.corrective-actions-panel .table td {\n  vertical-align: middle;\n  padding: 10px 12px;\n  color: #495057;\n}\n\n.corrective-actions-panel .table tbody tr {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.corrective-actions-panel .table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.corrective-actions-panel .table-danger td {\n  background-color: #f8d7da !important;\n  font-weight: 500;\n}\n\n.corrective-actions-panel .table small {\n  color: #6c757d;\n}\n\n.corrective-actions-panel .table .text-danger {\n  color: #dc3545 !important;\n}\n\n/* Status Badges */\n.corrective-actions-panel .badge {\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Action Buttons */\n.corrective-actions-panel .btn-group {\n  display: flex;\n  gap: 4px;\n}\n\n.corrective-actions-panel .btn-group-sm .btn {\n  padding: 4px 6px;\n  font-size: 0.8rem;\n  border-radius: 3px;\n}\n\n.corrective-actions-panel .btn-outline-secondary:hover {\n  background-color: #6c757d;\n  border-color: #6c757d;\n  color: white;\n}\n\n.corrective-actions-panel .btn-outline-danger:hover {\n  background-color: #dc3545;\n  border-color: #dc3545;\n  color: white;\n}\n\n/* Delete Confirmation Alert */\n.corrective-actions-panel .alert-danger {\n  border-left: 4px solid #dc3545;\n  padding: 15px;\n  display: flex;\n  gap: 15px;\n  align-items: flex-start;\n}\n\n.corrective-actions-panel .alert-danger .d-flex {\n  gap: 10px;\n}\n\n.corrective-actions-panel .alert-danger svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.corrective-actions-panel .alert-danger p {\n  margin: 0;\n}\n\n/* Empty State */\n.corrective-actions-panel .alert-info {\n  border-left: 4px solid #0d6efd;\n  padding: 15px;\n}\n\n.corrective-actions-panel .alert-info p {\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .corrective-actions-panel {\n    padding: 15px;\n  }\n\n  .ca-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .ca-header .btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .corrective-actions-panel .table {\n    font-size: 0.8rem;\n  }\n\n  .corrective-actions-panel .table th,\n  .corrective-actions-panel .table td {\n    padding: 8px 6px;\n  }\n\n  .ca-form .row {\n    gap: 0;\n  }\n\n  .ca-form .col-md-6 {\n    margin-bottom: 10px;\n  }\n\n  .corrective-actions-panel .btn-group {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .corrective-actions-panel .btn-group .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
